<script lang="typescript">
    export let text: string = "Subtitle 2/Roboto/Medium/14px";
    export let color = "var(--color-level-7)";
    export let style = "";
</script>

<label style="color: {color}; {style}" class="subtitle2" for="">{text}</label>

<style>
    .subtitle2 {
        /* Subtitle 2 */
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        /* identical to box height, or 171% */
        letter-spacing: 0.1px;

        pointer-events: none;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
